import React, {useState, useEffect} from 'react';
import {Route, Switch, useLocation} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {Row} from 'reactstrap';

import axios from './axios-base';
import Home from './containers/Home/Home';
import SignUp from './containers/SignUp/SignUp';
import ProjectList from './containers/ProjectList/ProjectList';
import Project from './containers/Project/Project';
import Page from './components/Page/Page';
import Auth from './containers/Auth/Auth';
import Logout from './containers/Auth/Logout/Logout';
import JuryShell from './containers/JuryVoting/JuryShell/JuryShell';
import withErrorHandler from './hoc/withErrorHandler/withErrorHandler';
import * as actions from './store/actions/index';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ConsentModal from './components/UI/Modal/ConsentModal/ConsentModal';
import Cookies from 'js-cookie';
import {Helmet} from "react-helmet";
import {personalization, statisticTracking} from "./shared/trackingScripts";
import ScrollToTop from './shared/scrollToTop';
import PageNotFound from './components/Page/PageNotFound.js';
import SMSRequest from "./containers/SMSRequest/SMSRequest";
import {useFeatureFlag} from './shared/config';


function App(props) {
    const location = useLocation();
    const dispatch = useDispatch();
    const isJuryRoot = location.pathname.startsWith('/jury');
    const [pageNotFound, setPageNotFound] = useState(false);
    const [pages, setPages] = useState(null);
    const [navigation, setNavigation] = useState({});


    const pageNotFoundCallback = (pageState) => {
        setPageNotFound(pageState);
    };


    useEffect(() => {
        dispatch(actions.authCheckState());
        const pages = axios.get('/pages/')
        const navigation = axios.get('/menus/')

        Promise.all([pages, navigation]).then(([resPages, resNavigation]) => {
            if (process.env.REACT_APP_BUILD_FOR_ARCHIVAL === "true") {
                resNavigation.data = resNavigation.data.filter((item) => item.linkTarget !== "/bewerbung");
            }

            const primaryNavigation = resNavigation.data.filter(menuItem => {
                return menuItem.position === 'primary' && menuItem.highlight === false
            })
            const primaryNavigationCTA = resNavigation.data.filter(menuItem => {
                return menuItem.position === 'primary' && menuItem.highlight === true
            })
            const secondaryNavigation = resNavigation.data.filter(menuItem => {
                return menuItem.position === 'secondary'
            })
            setPages(resPages.data);
            setNavigation({
                primaryNavigation: primaryNavigation,
                primaryNavigationCTA: primaryNavigationCTA,
                secondaryNavigation: secondaryNavigation
            })
        }).catch(error => {
            console.log(error);
        })
    }, [dispatch])

    let dynamicPages = null;
    let dynamicHeader = null;
    let consentManagementModal = null;
    let pageNotFoundRoute = null;

    // Check if cookies exist and display consent management modal OR load tracking scripts
    if (Cookies.get('bigfoot_personalization-consent') === 'true' && Cookies.get('bigfoot_statistic-consent') === 'true') {
        dynamicHeader = <Helmet>{personalization()}{statisticTracking()}</Helmet>
    } else if (Cookies.get('bigfoot_statistic-consent') === 'true') {
        dynamicHeader = <Helmet>{statisticTracking()}</Helmet>
    } else if (Cookies.get('bigfoot_personalization-consent') === 'true') {
        dynamicHeader = <Helmet>{personalization()}</Helmet>
    }

    if (Cookies.get('bigfoot_cookie-consent') !== 'true') {
        consentManagementModal = <ConsentModal pages={pages}/>
    }

    if (pages) {
        pageNotFoundRoute =
            <Route path="*" status={404} render={() => <PageNotFound pageNotFoundCallback={pageNotFoundCallback}/>}/>;
        dynamicPages = (
            pages.filter(page => !page.slug.startsWith('jury/')).map((page, i) => {
                return (
                    /* The following component is monitored by Font Awesome dom.watch(). Check children */
                    <Route
                        key={i}
                        exact //Caution: This may redirect to 404 pag if embedded links are opened from the page.
                        path={`/${page.slug}`}
                        render={(props) => <Row id="dom-watch"><Page pageTitle={page.title}
                                                                     pageBody={page.body}
                                                                     survey={page.survey} {...props}
                        /></Row>}
                    />
                )
            })
        )
    }

    return (
        <div className={isJuryRoot ? "overflow-x-hidden" : "container-lg"}>
            {dynamicHeader}
            {consentManagementModal}
            {!isJuryRoot && (
                <Header
                    primaryNavigation={navigation.primaryNavigation}
                    primaryNavigationCTA={navigation.primaryNavigationCTA}
                    pageNotFound={pageNotFound}/>
            )} <ScrollToTop/>
            <div className="visually-hidden" id="content"/>
            <Switch>
                {dynamicPages}
                <Route
                    path="/projekte/:id"
                    render={(props) => <Project {...props} />}/>
                <Route path="/code-anfordern"
                       render={(props) => <SMSRequest {...props} />}/>
                {useFeatureFlag("juryVoting") ? <Route path="/jury" component={JuryShell}/> : null}
                <Route path="/projekte" render={(props) => <ProjectList/>}/>
                <Route path="/bewerbung" render={(props) => <SignUp {...props} />}/>
                <Route path="/logout" component={Logout}/>
                <Route path="/login" component={Auth}/>
                <Route path="/" exact render={(props) => <Home {...props} />}/>
                {pageNotFoundRoute}
            </Switch>
            <Footer secondaryNavigation={navigation.secondaryNavigation} contained={isJuryRoot}/>
        </div>
    );
}

export default withErrorHandler(App, axios);
